import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { SnackbarProvider } from './Components/Snackbar/SnackBarContext';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import store from './StateManagement/store';
import { ThemeContextProvider } from './Context/ThemeContext';
const initialOptions = {
  "clientId": "sb-8z5bb3685001@personal.example.com", // Replace with your PayPal Client ID
  currency: "INR", // Set your desired currency
};

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
ReactDOM.render(
  <Provider store={store}>
   <ThemeContextProvider>
     <SnackbarProvider>
      <App />
    </SnackbarProvider>
   </ThemeContextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
